// PublicRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  const isAuth = localStorage.getItem('isAuth') === 'true';
  // If authenticated, redirect to the main page.
  if (isAuth) {
    return <Navigate to="/main" replace />;
  }

  return children;
};

export default PublicRoute;
